import React, { Fragment } from "react";
import { Trans } from "react-i18next";

import { NORMAL, HIGHLIGHT, REVIEW } from "constant/filetype";
import { READ_SUBSCRIPTION } from "constant/auth";

const VodTypeIcon = ({ fileType, isPpvBj = false, auth_no }) => (
    <Fragment>
        {auth_no && auth_no === READ_SUBSCRIPTION ? (
            <span className="subscribe">
                구독전용
            </span>
            ) : (
            <>
                {fileType === REVIEW && (
                    <em className="ic-replay">
                        다시보기
                    </em>
                )}
                {isPpvBj === true && <span className="ic_ppv"><Trans>유료</Trans></span>}
            </>
        )}
    </Fragment>
);

export default VodTypeIcon;
